(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6340],{

/***/ 61062:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopper",
      function () {
        return __webpack_require__(40191);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
function safeGetLocalStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
}
function setListener(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
}
// biome-ignore lint/suspicious/noExplicitAny: Allow saving anything in local storage
function setItem(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
}
function getItem(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string ? JSON.parse(string) : string;
}
function removeItem(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 4638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.ts
var local_storage = __webpack_require__(47878);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js

function broadcastMessageToTabs(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
}

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.ts

function safeGetSessionStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
}
function isAvailable() {
    return !!safeGetSessionStorage();
}
function getItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string && JSON.parse(string);
}
function setItem(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
}
function removeItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 92146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40891);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61866);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47878);



function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
}
function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
}
var FilterWrapper = {
    track: function track(event, properties) {
        if (!(isInternalUser() || isKnownBot())) {
            var ref;
            (ref = window.FS) === null || ref === void 0 ? void 0 : ref.call(window, "trackEvent", {
                name: event,
                properties: properties
            });
        } else {
            // biome-ignore lint/suspicious/noConsole: debug
            console.log("INTERNAL USER - Track: ", event, properties);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 98322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17211);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52473);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4638);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45511);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29342);
/* harmony import */ var _client_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92146);
/* harmony import */ var _head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71748);
/* harmony import */ var _page_level_progress_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74967);








var defaultDescription = "Purple Dot lets you sell sooner to shoppers who are willing to wait. Bring products to market faster, test demand or avoid deep discounts.";
function Page(param) {
    var pageName = param.pageName, title = param.title, _titleSuffix = param.titleSuffix, titleSuffix = _titleSuffix === void 0 ? "Purple Dot" : _titleSuffix, noIndex = param.noIndex, description = param.description, head = param.head, children = param.children;
    useTrackingData(pageName);
    var titleText = "".concat(title).concat(titleSuffix ? " | " : "").concat(titleSuffix);
    var descriptionText = description || defaultDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_page_level_progress_bar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        id: pageName,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_head__WEBPACK_IMPORTED_MODULE_4__/* .Head */ .F, {
                title: titleText,
                description: descriptionText,
                noIndex: noIndex,
                children: head
            }),
            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children, Function) ? children({
                title: titleText,
                description: descriptionText
            }) : children
        ]
    });
}
function useTrackingData(pageName) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    // Track when the user navigates away from their first page so we can set up exit rate
    // as a metric in our analytics and ad tools
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function trackUserProgressed() {
            if (!(0,_purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__/* .getItem */ .rV)("userProgressed")) {
                _client_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].trackUserProgressed */ .Z.trackUserProgressed(pageName);
            }
            (0,_purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__/* .setItem */ .LS)("userProgressed", true, {
                broadcast: false
            });
            router.events.off("routeChangeComplete", trackUserProgressed);
        }
        router.events.on("routeChangeComplete", trackUserProgressed);
    }, [
        pageName,
        router.events
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 71748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52473);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98363);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29342);
/* harmony import */ var _fullstory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34153);




function Head(param) {
    var title = param.title, description = param.description, noIndex = param.noIndex, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== null && title !== void 0 ? title : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description !== null && description !== void 0 ? description : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                sizes: "180x180",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/static/favicon-mask.svg",
                color: "#5bbad5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/static/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/static/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/static/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fullstory__WEBPACK_IMPORTED_MODULE_3__/* .FullStorySnippet */ .S, {}),
            noIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            children
        ]
    });
}


/***/ }),

/***/ 74967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97912);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25425);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21582);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73588);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45511);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64279);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29342);







var PageLevelProgressBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PageLevelProgressBar, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PageLevelProgressBar);
    function PageLevelProgressBar() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PageLevelProgressBar);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(PageLevelProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeStart", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().start();
                });
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeComplete", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                });
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeError", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children;
            }
        }
    ]);
    return PageLevelProgressBar;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (PageLevelProgressBar);


/***/ }),

/***/ 40191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shopper; }
});

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(11204);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(58207);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(80460);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52473);
// EXTERNAL MODULE: ../../../../libraries/src/fetch.ts
var fetch = __webpack_require__(78960);
// EXTERNAL MODULE: ../../../../placement-iframe/index.ts + 1 modules
var placement_iframe = __webpack_require__(574);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/image.js
var next_image = __webpack_require__(91288);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(29342);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/styled-components@5.3.11_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(1578);
// EXTERNAL MODULE: ./components/common/Branding.tsx + 3 modules
var Branding = __webpack_require__(936);
// EXTERNAL MODULE: ./components/common/linking.tsx
var linking = __webpack_require__(7307);
;// CONCATENATED MODULE: ./components/shopper/images/ShopperImage.jpg
/* harmony default export */ var ShopperImage = ({"src":"/_next/static/media/ShopperImage.a01d3210.jpg","height":930,"width":1125,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAcACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAAAwX/2gAMAwEAAhADEAAAAK0UW//EAB0QAAIABwEAAAAAAAAAAAAAAAEDAAQREhQiQnH/2gAIAQEAAT8AVjrl7QirgOjp7H//xAAYEQACAwAAAAAAAAAAAAAAAAAAARJhkf/aAAgBAgEBPwCKvT//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./components/shopper/ShopperPage.jsx + 1 modules
var ShopperPage = __webpack_require__(23096);
// EXTERNAL MODULE: ./components/shopper/svgs/Logo.svg
var Logo = __webpack_require__(15813);
// EXTERNAL MODULE: ./components/shopper/ThemedButton.tsx
var ThemedButton = __webpack_require__(75984);
// EXTERNAL MODULE: ./components/use-translation.ts + 7 modules
var use_translation = __webpack_require__(88724);
// EXTERNAL MODULE: ./webserver-page.tsx
var webserver_page = __webpack_require__(82673);
;// CONCATENATED MODULE: ./pages/shopper/index.jsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :root {\n    --text-color-primary: ",
        ";\n    --text-color-secondary: ",
        ";\n  }\n\n  body {\n    background-color: ",
        ";\n  }\n\n  * {\n    font-family: ",
        ";\n    color: var(--text-color-primary);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100vh;\n\n  .form-section {\n    flex-grow: 1;\n    height: 100%;\n    max-width: 640px;\n    background: white;\n  }\n\n  .image-section {\n    position: relative;\n    flex-grow: 1;\n  }\n\n  @media (width <= 700px) {\n    .image-section {\n      display: none;\n    }\n\n    .form-section {\n      max-width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  form {\n    display: flex;\n    flex-direction: column;\n    width: 330px;\n    max-width: 400px;\n    margin-bottom: 37px;\n\n    ",
        "\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    font-size: 16px;\n    margin-bottom: 28px;\n  }\n\n  label > input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    line-height: 48px;\n    color: fieldtext;\n  }\n\n  label > input::placeholder {\n    color: var(--text-color-secondary);\n  }\n\n  label:last-of-type {\n    margin-bottom: 15px;\n  }\n\n  form > button {\n    display: inline-block;\n    margin-top: 14px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  @media (width <= 700px) {\n    form {\n      display: flex;\n      flex-direction: column;\n      min-width: inherit;\n    }\n\n    form > button {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 37px;\n  margin-bottom: 37px;\n\n  @media (width <= 700px) {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














function SelfServicePage(param) {
    var embedded = param.embedded, overlayData = param.overlayData;
    (0,react.useEffect)(function() {
        if (embedded) {
            (0,placement_iframe/* connectToPlacementParent */.L6)().then(function() {
            // Connect to the parent to simply resize the iframe
            // no need to store the connection
            });
        }
    }, []);
    if (embedded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopperPage/* default */.Z, {
            pageName: "Embedded self-service",
            embedded: embedded,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCSS, {
                    globalCSS: overlayData.head.globalCSS
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
                    theme: overlayData.theme,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupFormContainer, {
                            embedded: embedded,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupForm, {
                                embedded: embedded
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopperPage/* default */.Z, {
        pageName: "Self-service",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCSS, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: overlayData.theme,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupFormContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupForm, {})
                        })
                    })
                ]
            })
        ]
    });
}
var GlobalCSS = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, function(param) {
    var theme = param.theme;
    return theme.modal.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
});
var PageLayout = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-section",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: ShopperImage,
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "left",
                    quality: 90,
                    placeholder: "blur",
                    priority: true
                })
            })
        ]
    });
}).withConfig({
    componentId: "sc-7eea5d24-0"
})(_templateObject2());
var LookupFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7eea5d24-1"
})(_templateObject3(), function(param) {
    var embedded = param.embedded;
    return embedded ? "fit-content" : "100vh";
});
var LookupForm = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, embedded = param.embedded;
    var ref = (0,react.useState)(""), reference = ref[0], setReference = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,use_translation/* useTranslation */.$)(), t = ref4.t, i18n = ref4.i18n;
    (0,react.useEffect)(function() {
        var explicitLocale = new URLSearchParams(window.location.search).get("locale");
        var browserLocale = window.navigator.language.split("-")[0];
        var locale = explicitLocale || browserLocale;
        if (locale) {
            i18n.changeLanguage(locale);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        id: "shopper-portal-login",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HideForEmbedded, {
                embedded: embedded,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            maxWidth: "167px",
                            marginBottom: "40px",
                            marginLeft: "3px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTitle, {
                        children: t("translation:self-service.index.find-your-pre-order")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        var ref, success, redirect, err;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    setLoading(true);
                                    return [
                                        4,
                                        (0,fetch/* postJSON */.ty)("/shopper/lookup".concat(window.location.search), {
                                            email: email,
                                            reference: reference,
                                            embedded: embedded,
                                            locale: i18n.resolvedLanguage
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), success = ref.success, redirect = ref.redirect, err = ref.error;
                                    if (success) {
                                        (0,linking/* routeTo */.E)(redirect);
                                    } else {
                                        setLoading(false);
                                        setError(err);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "lookup-reference",
                        children: [
                            t("translation:self-service.index.reference-number"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "lookup-reference",
                                "data-testid": "lookup-reference",
                                type: "text",
                                name: "reference",
                                placeholder: "#PD123456",
                                value: reference,
                                onChange: function onChange(e) {
                                    return setReference(e.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "lookup-email",
                        children: [
                            t("translation:self-service.index.email"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "lookup-email",
                                "data-testid": "lookup-email",
                                type: "text",
                                name: "email",
                                value: email,
                                onChange: function onChange(e) {
                                    return setEmail(e.target.value);
                                }
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        "data-testid": "lookup-error",
                        style: {
                            color: "red"
                        },
                        children: error
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedButton/* default */.Z, {
                        "data-testid": "lookup-submit",
                        type: "submit",
                        embedded: embedded,
                        disabled: loading,
                        children: t("translation:self-service.index.find-pre-order-cta")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HideForEmbedded, {
                embedded: embedded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Branding/* default */.Z, {})
            })
        ]
    });
}).withConfig({
    componentId: "sc-7eea5d24-2"
})(_templateObject4(), function(param) {
    var embedded = param.embedded;
    return embedded && "\n      position: relative;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    ";
}, function(param) {
    var theme = param.theme;
    return theme.borderColor;
});
var FormTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-7eea5d24-3"
})(_templateObject5());
function HideForEmbedded(param) {
    var children = param.children, embedded = param.embedded;
    return embedded ? null : children;
}
/* harmony default export */ var shopper = ((0,webserver_page/* default */.Z)(SelfServicePage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2130,8287,9515,1288,7070,5051,9912,9774,2888,179], function() { return __webpack_exec__(61062); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);